import type { Tag, Workspace } from '@carboncopyco/types';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';

export const WorkspaceManageTagListRowWrapper = ({
  item,
  children,
}: {
  item: Workspace | Tag;
  children: ReactNode;
}) => {
  const { selectedTags } = useWorkspaceManageTag();

  const onToggle = () => {
    if (selectedTags.has(item.id)) {
      return selectedTags.delete(item.id);
    }

    selectedTags.add(item.id);
  };

  return (
    <div
      onClick={onToggle}
      className={classNames(
        'group px-2 my-1 rounded-md pointer cursor-pointer flex items-center w-full',
        selectedTags.has(item.id)
          ? 'bg-ds-primary-50'
          : 'hover:bg-ds-natural-50'
      )}
    >
      {children}
    </div>
  );
};
